import React from 'react';
import { ServiceTimeRangeCount } from '@Dashboard/Charts/ServiceTimeRangeCount';
import { useTranslation } from 'react-i18next';

import DashboardCard from '../../Layout/DashboardCard';

function SecurityRiskDetectionCount(props: { data: any; day: string }) {
  const { t } = useTranslation();

  return (
    <DashboardCard
      row={2}
      height="628px"
      title={t('dashboard.chart.title.atpThreatCount')}
    >
      <ServiceTimeRangeCount
        data={props.data?.security_risk_scanThreatDetectionCount?.[props.day]}
        interval={props.day}
        height="555px"
      />
      {/* <LineTemplate
        type={LineTemplateType.Service}
        data={props.data?.security_risk_scanThreatDetectionCount?.[props.day]}
        height="555px"
      /> */}
    </DashboardCard>
  );
}

export default React.memo(SecurityRiskDetectionCount);
